<template>
  <div class="exam-profiles-list">
    <modal
      ref="deleteExamProfile"
      template="question"
      title="Aviso"
      ref-name="deleteExamProfile"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      @first-cta="closeModal()"
      @second-cta="handleDelete()"
    >
      <p>Tem certeza que deseja excluir o perfil de exames?</p>
      <div class="exam-profiles-list__modal-text">
        <span v-html="selectedItem ? selectedItem.name : ''" />
      </div>
    </modal>

    <div
      v-if="examProfilesIsLoading"
      class="loading"
    >
      <spinner />
    </div>
    <div v-else>
      <data-table
        v-if="filteredArray && filteredArray.length > 0"
        :header="table.header"
        is-sticky
      >
        <div
          v-for="(examProfile, index) in filteredArray"
          :key="index"
          class="data-table__body__row"
          @click="showDetail(examProfile.id, $event)"
        >
          <data-cell :size="25">
            <p class="name ellipsable">
              {{ examProfile.name }}
              <md-tooltip md-direction="top">
                {{ examProfile.name }}
              </md-tooltip>
            </p>
          </data-cell>

          <data-cell :size="25">
            <p class="regular ellipsable">
              {{ examProfile.author }}
              <md-tooltip md-direction="top">
                {{ examProfile.author }}
              </md-tooltip>
            </p>
          </data-cell>

          <data-cell :size="20">
            <p class="regular ellipsable">
              <template v-if="examProfile.exams.length > 1">
                <span>{{ examProfile.exams.length + ' exames' }}</span>
                <md-tooltip md-direction="top">
                  {{ examProfile.exams.length + ' exames' }}
                </md-tooltip>
              </template>
              <template v-else>
                <span>{{ examProfile.exams.length + ' exame' }}</span>
                <md-tooltip md-direction="top">
                  {{ examProfile.exams.length + ' exame' }}
                </md-tooltip>
              </template>
            </p>
          </data-cell>

          <data-cell :size="15">
            <p
              v-if="profile.id_laboratory === examProfile.id_matriz"
              class="regular ellipsable"
            >
              <template v-if="examProfile.laboratories && examProfile.laboratories.length > 1">
                <span>{{ examProfile.laboratories.length + ' filiais' }}</span>
                <md-tooltip md-direction="top">
                  {{ examProfile.laboratories.length + ' filiais' }}
                </md-tooltip>
              </template>
              <template v-else-if="examProfile.laboratories && examProfile.laboratories.length">
                <span>{{ examProfile.laboratories.length + ' filial' }}</span>
                <md-tooltip md-direction="top">
                  {{ examProfile.laboratories.length + ' filial' }}
                </md-tooltip>
              </template>
              <template v-else>
                <span class="trace"> - </span>
              </template>
            </p>
          </data-cell>

          <data-cell
            :size="10"
            class="actions-cell"
          >
            <div
              v-if="profile.id_laboratory === examProfile.id_laboratory_owner"
              class="actions-container"
            >
              <div
                class="status-icon icon-edit-alt"
                @click="handleEdit(examProfile)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
              </div>
              <div
                id="delete"
                class="status-icon icon-delete-alt"
                @click="openDeleteModal(examProfile)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
            </div>
          </data-cell>

          <data-cell :size="5">
            <img
              src="/static/images/icon-arrow-dropdown-alt.svg"
              :class="{'exam-profiles-list__detail-row--active': examProfile.showDetail}"
              alt="icone-ver-mais"
            >
          </data-cell>

          <ExamProfilesDetail
            :exams="examProfile.exams"
            :branches-related="examProfile.laboratories"
            :show="examProfile.showDetail"
            :is-headquarter="examProfile.id_matriz === profile.id_laboratory"
          />
        </div>
      </data-table>
      <div
        v-if="filteredArray && filteredArray.length === 0 && !examProfilesIsLoading"
        class="no-results"
      >
        <div class="img-wrapper">
          <img
            src="/static/images/no-file-img.svg"
            alt="sem-resultados"
          >
        </div>
        <p>Nenhum perfil de exames cadastrado.</p>
        <p>Para adicionar perfis de exame, selecione:</p>
        <button @click="$router.push('/exam-profiles/new')">
          NOVO PERFIL DE EXAMES
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../common/dataTable/DataTable'
import DataCell from '../common/dataTable/DataCell'
import Spinner from '@/components/common/Spinner'
import InfiniteLoading from '@/components/common/InfiniteLoading'
import ExamProfilesDetail from '@/components/ExamProfiles/ExamProfilesDetail'

import fuzzysort from 'fuzzysort'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ExamProfilesList',
  components: {
    ExamProfilesDetail,
    DataTable,
    DataCell,
    InfiniteLoading,
    Spinner
  },
  props: {
    filterInput: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      selectedItem: null
    }
  },
  methods: {
    ...mapActions(['examProfilesGetAll']),
    ...mapActions(['examProfileDelete']),
    closeModal () {
      this.$refs.deleteExamProfile.close()
    },
    openDeleteModal (item) {
      this.selectedItem = item
      this.$refs.deleteExamProfile.open()
    },
    showDetail (id, event) {
      if (event.target.id !== 'delete') {
        this.filteredArray = this.filteredArray.map((item) => {
          if (item.id === id) {
            item.showDetail = !item.showDetail
          }
          return item
        })
      }
    },
    handleEdit (examProfile) {
      this.$router.push({
        path: '/exam-profiles/edit/' + examProfile.id
      })
    },
    handleDelete () {
      this.examProfileDelete(this.selectedItem)
      this.closeModal()
    }
  },
  computed: {
    ...mapGetters(['examProfilesIsLoading']),
    ...mapGetters(['examProfilesList']),
    ...mapGetters(['profile']),
    filteredArray: {
      get () {
        if (this.filterInput) {
          if (this.filterInput.length > 0) {
            let result = fuzzysort.go(this.filterInput, this.examProfilesList, {
              keys: ['name', 'author'],
              limit: 1000,
              allowTypo: true,
              threshold: -10000
            })
            result = result.map((item) => {
              item = item.obj
              return item
            })
            return result
          }
        } else {
          return this.examProfilesList
        }
      },
      set (newVal) {
        return newVal
      }
    },
    table () {
      return {
        header: [
          {
            title: 'Perfil de exame',
            subtitle: 'Nome',
            size: 25
          },
          {
            title: 'Responsável',
            subtitle: '',
            size: 25
          },
          {
            title: 'Exames',
            subtitle: 'Quantidade',
            size: 20
          },
          (this.filteredArray.length && this.filteredArray[0].id_matriz === this.profile.id_laboratory ? {
            title: 'Filiais',
            subtitle: 'Relacionadas',
            size: 30
          } : {})
        ]
      }
    }
  },
  mounted () {
    this.examProfilesGetAll()
  }
}
</script>

<style lang="scss">
.exam-profiles-list {
  margin-bottom: 40px;
  width: 100%;

  &__modal-text {
    text-align: center;
    padding: 15px;
    background: #f5f5f5;
    border-radius: 5px;

    span {
      font-weight: 500;
      font-size: 16px;
      color: #4a4a4a;
      letter-spacing: 0;
    }
  }

  &__show-detail {
    min-height: 58px;
    cursor: pointer;
  }

  .data-table {
    &__header {
      &__row {
        height: auto !important;
        &--sticky {
          height: 50px !important;
          display: flex;
          align-items: flex-end;
          padding-bottom: 10px;
        }
        &__cell {
          padding: 0 16px !important;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          margin-bottom: 5px;

          h3, p {
            font-weight: 500;
          }
        }
      }
    }
    &__body {
      &__row {
        width: 100%;
        min-height: auto !important;
        cursor: pointer;
        margin-bottom: 8px;
        box-shadow: 0px 1px 4px rgba(121, 121, 121, 0.12);

        &__cell {
          padding: 0 16px;

          p {
            cursor: pointer;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 26px;
            padding: 16px 0;
          }
        }
      }
    }
  }
  .actions-cell {
    padding: 0 !important;
  }

  &__detail-row {
    line-height: 26px;
    &--active {
      transform: rotate(180deg);
    }
  }

  .loading {
    min-height: 60vh;
    display: flex;
    align-items: center;
  }

  .no-results {
    color: #7a7a7a;
    text-align: center;
    min-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    .img-wrapper {
      margin-bottom: 35px;
    }
    p {
      font-size: 16px;
      margin-bottom: 20px;
      &:first-of-type {
        font-size: 20px;
      }
    }
    button {
      font-size: 10px;
      color: #fff;
      font-weight: 500;
      background-color: #55cd9e;
      padding: 8px 16px;
      height: auto;
      margin: 10px 0;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .infinite-loading-container {
    min-height: 30vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ellipsable {
    font-size: 14px;
    text-transform: none;
    width: 100%;
    color: #4A4A4A;
  }
  .name {
    font-style: normal;
    font-weight: 500;
  }

  .regular {
    font-weight: normal;
    font-size: 14px;

    .trace {
      display: block;
      text-align: center;
    }
  }

  .actions {
    &-container {
      display: none;

      div {
        margin: 0 0.4em;
      }
    }
    &-cell {
      padding-left: 0;
    }
  }

  .data-table__body__row {
    min-height: 5.5em;
    &__cell {
      display: flex;
      align-items: center;
    }
    &:hover {
      .actions {
        &-container {
          display: inline-flex;
        }
      }
    }
  }
}
</style>
